/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FlexLayout } from '@waca/ca-ui-toolkit';
import './Overlay.scss';

export default class Overlay extends Component<any, any> {
	static propTypes = {
		children: PropTypes.node,
	};

	render() {
		const { children } = this.props;

		return (
			<FlexLayout justifyContent="center" className="bi-common-overlay">
				{children}
			</FlexLayout>
		);
	}
}
